'use client';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import { fadeUpAosProps, getAosDelay, mergeAos } from '@utils/aosProps';
import CustomVideo from '@components/CustomVideo';
import CustomImage from '@components/CustomImage';

import cn from './style.module.scss';

export default function LsqSodicBanner(props: MarketingPageComponentProps) {
  const bannerSection = props?.locale?.section?.find(
    (section: any) => section.type === 'banner' && section.enabled
  );
  if (!bannerSection) return null;

  const imageStory = bannerSection?.lsqSodicBannerImageStory;
  const videoStory = bannerSection?.lsqSodicBannerVideoStory;
  const hasImage = !!(imageStory?.desktop?.url || imageStory?.mobile?.url);
  const hasVideo = !!(videoStory?.desktop?.url || videoStory?.mobile?.url);

  if (!hasImage && !hasVideo) return null;

  return (
    <Stack component="section" className={cn.sodicBannerWrapper}>
      <Box className={cn.sodicBannerInner}>
        {hasImage ? (
          <Box
            className={cn.sodicBannerStory}
            {...mergeAos(fadeUpAosProps, getAosDelay(200))}
          >
            <Mobile>
              <CustomImage
                src={imageStory?.mobile?.url}
                alt={imageStory?.mobile?.alt}
                width={640}
                height={360}
              />
            </Mobile>
            <Desktop>
              <CustomImage
                src={imageStory?.desktop?.url}
                alt={imageStory?.desktop?.alt}
                width={1920}
                height={1080}
              />
            </Desktop>
          </Box>
        ) : null}
        {hasVideo ? (
          <Box
            className={cn.sodicBannerStory}
            {...mergeAos(fadeUpAosProps, getAosDelay(200))}
          >
            <Mobile>
              <CustomVideo
                showMuteControl={true}
                controlPosition="overlay"
                customControlClassName={cn.sodicBannerMuteButton}
                src={videoStory?.mobile?.url}
                poster={videoStory?.mobile?.poster}
              />
            </Mobile>
            <Desktop>
              <CustomVideo
                showMuteControl={true}
                controlPosition="overlay"
                customControlClassName={cn.sodicBannerButton}
                src={videoStory?.desktop?.url}
                poster={videoStory?.desktop?.poster}
              />
            </Desktop>
          </Box>
        ) : null}
      </Box>
    </Stack>
  );
}
